import eventbus from 'tiny-emitter/instance';
import SelectionBox from '@/core/utils/selectionBox';
import { allowCtrlA, allowEsc } from '../helper';
/* eslint-disable */
export default class BlockSeatsMode {
  constructor(app) {
    this.app = app;
    this.seatmap = app.seatmap;
    this.selection = this.app.seatmap.selection;
    this.initSelectionBox();

    allowCtrlA(this);
    allowEsc(this);
    return this;
  }

  // setup() {
  //   this.addEventListeners();
  //   eventbus.emit('seatmap:lock:show');
  //   eventbus.emit('seatmap:labels:hide');
  // }
  //
  // addEventListeners() {
  //   eventbus.on('seats:lock', this.lockSelectedSeats, this);
  //   eventbus.on('seats:unlock', this.unlockSelectedSeats, this);
  // }
  //
  // removeEventListeners() {
  //   eventbus.off('seats:lock', this.lockSelectedSeats);
  //   eventbus.off('seats:unlock', this.unlockSelectedSeats);
  // }
  //
  // lockSelectedSeats() {
  //   this.selection.items.forEach(item => item.lock());
  //   eventbus.emit('seats:lock:updated');
  // }
  //
  // unlockSelectedSeats() {
  //   this.selection.items.forEach(item => item.unlock());
  //   eventbus.emit('seats:lock:updated');
  // }

  initSelectionBox() {
    this.selectionBox = new SelectionBox(this.app);
    eventbus.emit('seatmap:changemode');
  }

  removeSelectionBox() {
    this.selectionBox.destroy();
    delete this.selectionBox;
  }

  destroy() {
    this.removeSelectionBox();
    // this.removeEventListeners();
    // eventbus.emit(`seatmap:lock:${this.app.showLocks ? 'show' : 'hide'}`);
  }
}
